var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1850.7 1850.7",
    style: {
      enableBackground: "new 0 0 1850.7 1850.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#06EC97;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 925.3,
    cy: 925.3,
    r: 925.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.9,426.9c-37,0-71.4,19.1-90.8,50.6L1019,786.9c-6.8,10.2-4,23.9,6.2,30.7c8.3,5.5,19.3,4.8,26.8-1.6l205.8-177.9 c3.4-3.1,8.7-2.8,11.8,0.7c1.4,1.6,2.1,3.6,2.1,5.7v557c0,4.6-3.7,8.3-8.4,8.3c-2.5,0-4.8-1.1-6.4-3l-622-742.2 c-20.3-23.8-50-37.6-81.3-37.6h-21.7c-58.8,0-106.5,47.5-106.5,106.2v784.5c0,58.6,47.7,106.2,106.5,106.2 c37,0,71.4-19.1,90.8-50.6l209.1-309.4c6.8-10.2,4-23.9-6.2-30.7c-8.3-5.5-19.3-4.8-26.8,1.6l-205.8,177.9 c-3.4,3.1-8.7,2.8-11.8-0.7c-1.4-1.6-2.1-3.6-2.1-5.7V649.2c0-4.6,3.7-8.3,8.3-8.3c2.5,0,4.8,1.1,6.4,3l622,742.3 c20.3,23.8,50,37.6,81.3,37.6h21.7c58.8,0,106.6-47.5,106.6-106.1V533.1C1425.4,474.5,1377.7,426.9,1318.9,426.9L1318.9,426.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNearIcon);
export default __webpack_public_path__ + "static/media/near_icon.af86cd2a27e17f18ba5988e05b2be2f8.svg";
export { ForwardRef as ReactComponent };